
import { defineComponent } from 'vue'

import IgnoreAIReviewIssueMutation from '~/apollo/mutations/issue/ignoreAiReview.gql'
import ActiveUserMixin from '~/mixins/activeUserMixin'

import type { FetchResult } from 'apollo-link'
import type { IgnoreAiReviewIssueMutation } from '~/types/types'

export default defineComponent({
  name: 'IgnoreAiReviewIssue',
  mixins: [ActiveUserMixin],
  emits: ['close', 'ignore'],
  props: {
    aiReviewIssueId: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      this.isLoading = true
      try {
        const response: FetchResult<IgnoreAiReviewIssueMutation> = await this.$applyGraphqlMutation(
          IgnoreAIReviewIssueMutation,
          {
            input: { id: this.aiReviewIssueId }
          }
        )
        if (response.data?.ignoreAiReviewIssue?.ok) {
          this.$toast.success('Ignored the AI Review issue.')
          this.$emit('ignore', [this.aiReviewIssueId])
        } else {
          throw new Error('Received a non-ok response')
        }
      } catch (e) {
        this.logErrorForUser(
          e as Error,
          'Ignore AI Review Issue',
          {
            method: 'Ignore AI Review issue',
            aiReviewIssueId: this.aiReviewIssueId
          },
          'Something went wrong while ignoring this issue, please contact support.'
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
